var $2b12cc2a87e2d677$exports = {};
const $2b12cc2a87e2d677$var$pictureElements = document.querySelectorAll(".cursor-pointer");
let $2b12cc2a87e2d677$var$isImageVisible = false;
let $2b12cc2a87e2d677$var$centeredImg;
function $2b12cc2a87e2d677$var$toggleImageDisplay(event) {
    const pic = event.currentTarget.querySelector("img");
    if ($2b12cc2a87e2d677$var$isImageVisible) $2b12cc2a87e2d677$var$centeredImg.remove();
    else {
        $2b12cc2a87e2d677$var$centeredImg = document.createElement("img");
        $2b12cc2a87e2d677$var$centeredImg.src = pic.src;
        $2b12cc2a87e2d677$var$centeredImg.alt = pic.alt;
        $2b12cc2a87e2d677$var$centeredImg.classList.add("centered-image");
        document.body.appendChild($2b12cc2a87e2d677$var$centeredImg);
    }
    $2b12cc2a87e2d677$var$isImageVisible = !$2b12cc2a87e2d677$var$isImageVisible;
}
$2b12cc2a87e2d677$var$pictureElements.forEach((element)=>{
    element.addEventListener("click", $2b12cc2a87e2d677$var$toggleImageDisplay);
});
document.addEventListener("click", (event)=>{
    if ($2b12cc2a87e2d677$var$isImageVisible && event.target === $2b12cc2a87e2d677$var$centeredImg) $2b12cc2a87e2d677$var$toggleImageDisplay(event);
});


//# sourceMappingURL=certifications.f921f5ad.js.map
